import axios from "axios";
import { isDevMode, timeout } from "./utils";
import { API_POST_RESPONSE_MOCKS } from "../constants/mocks";

/**
 * A helper function to wrap the API call to
 * allow efficient dev-mode mocking.
 *
 * @param {string} route The API route to use
 * @param {object} data The data to submit
 */
const postToAPI = async (route, data) => {
  if (isDevMode()) {
    await timeout(1000);
    console.log("Submitted to " + route);
    console.log(data);
    return API_POST_RESPONSE_MOCKS[route] ?? null;
  }

  const response = await axios.post(route, data);
  return response;
};

export default postToAPI;
